/* global Word */
import { WordApiError } from '../../core/errors';

/**
 * Run a callback with the current document selection inside a Word.run context.
 * Ensures an initial context.sync() before invoking the callback and wraps
 * any errors as a `WordApiError` with an operation name.
 *
 * @param callback - function receiving (selection, context) and returning a Promise<T>
 */
export async function runAtCursor<T>(
  callback: (selection: Word.Range, context: Word.RequestContext) => Promise<T>
): Promise<T> {
  try {
    return await Word.run(async (context) => {
      const selection = context.document.getSelection();
      await context.sync();
      return await callback(selection, context);
    });
  } catch (err) {
    throw WordApiError.fromOfficeError(err, { operation: 'runAtCursor' });
  }
}
